<template>
  <v-navigation-drawer
    v-model="applicationStore.sideNavbarOpen"
    location="right"
    temporary
    :width="400"
  >
    <v-list-item
      lines="two"
      :title="userStore.user?.name || ''"
      :subtitle="userStore.user?.email || ''"
    >
      <template #subtitle="{ subtitle }">
        <p class="max-w-60 overflow-ellipsis line-clamp-1">
          {{ subtitle }}
        </p>
      </template>
      <template #prepend>
        <v-avatar variant="tonal">{{
          getInitials(userStore.user?.name || "")
        }}</v-avatar>
      </template>
      <template #append>
        <v-btn
          icon="mdi-arrow-right"
          variant="text"
          @click="() => (applicationStore.sideNavbarOpen = false)"
        ></v-btn>
      </template>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item
    v-if="systemStore.selectedSystem"
      lines="two"
      :title="'System: ' + systemStore.selectedSystem.system"
      :subtitle="systemStore.selectedSystem.supplierId"
    >
      <template #subtitle="{ subtitle }">
        <p class="max-w-60 overflow-ellipsis line-clamp-1">
          {{ subtitle }}
        </p>
      </template>
    </v-list-item>
    <v-divider></v-divider>

    <v-card variant="flat" :title="i18n.global.t('global.settings')">
      <template #text>
        <v-list>
          <!-- Remove documentation button because documentation is a empty document -->
          <!-- <v-list-item :title="i18n.global.t('global.documentation')">
            <template #append>
              <v-btn
                aria-label="Open application documentation"
                variant="tonal"
                href="https://www.rittal.com/imf/none/3_9181/"
                target="_blank"
                :title="i18n.global.t('global.documentation')"
              >
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
          </v-list-item> -->
          <v-list-item :title="i18n.global.t('global.theme')">
            <template #append>
              <v-switch
                aria-label="Skip entry loader animation"
                variant="tonal"
                :model-value="applicationStore.theme === 'dark'"
                @update:model-value="() => toggleDarkMode()"
                true-icon="mdi-weather-night"
                false-icon="mdi-white-balance-sunny"
                inset
                color="primary"
                hide-details
                :title="i18n.global.t('global.skipEntryAnimation')"
                class="ml-2"
              >
              </v-switch>
            </template>
          </v-list-item>
          <v-list-item :title="i18n.global.t('global.skipEntryAnimation')">
            <template #append>
              <v-switch
                aria-label="Skip entry loader animation"
                variant="tonal"
                :model-value="applicationStore.skipEntryAnimation"
                @update:model-value="
                  (val:string | boolean) => applicationStore.setSkipEntryAnimation(Boolean(val))
                "
                inset
                color="primary"
                hide-details
                :title="i18n.global.t('global.skipEntryAnimation')"
                class="ml-2"
              >
              </v-switch>
            </template>
          </v-list-item>
        </v-list>
      </template>
    </v-card>
    <template #append>
      <div class="p-2">
        <v-btn
          aria-label="Log out"
          variant="tonal"
          @click="LoginClient.getInstance().logOut()"
          block
          >{{ i18n.global.t("app.user.tooltip.logout") }}</v-btn
        >
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script lang="ts" setup>
import { i18n } from "@/locales";
import { LoginClient } from "@/login-client";
import { getInitials } from "@/helpers/textFormat";

//helpers
import { useApplicationStore, useSystemStore, useUserStore } from "@/store";

const applicationStore = useApplicationStore();
const userStore = useUserStore();
const systemStore = useSystemStore();

function toggleDarkMode() {
  applicationStore.setTheme(
    applicationStore.theme === "dark" ? "light" : "dark"
  );
}
</script>
<style lang="scss" scoped></style>
